<ng-template>
   <div lcsSingleSelectPanel [visible]="isPanelVisible">
      @if (isIncludeEmptyOption) {
      <lcs-option>{{ overrideEmptyOption !== '' ? overrideEmptyOption : '' }}</lcs-option>
      } @for (department of departments | async; track trackBy(department)) {
      <lcs-option [value]="department" id="lcs-option-id-{{ department.departmentId }}">
         {{ department.name }}
      </lcs-option>
      }
   </div>
</ng-template>
